import { Injectable } from '@angular/core';

import { ApiService }            from '../api/api.service';
import { CustomerModel }         from './models/customer';
import { CustomersFiltersModel } from './typings/customers.filters';
import { MessengerService }      from '../messages/messenger/messenger.service';
import { TableQueryParameters }  from '../table/types/table-query-parameters';

@Injectable({
  providedIn: 'root'
})
export class CustomersService {
  public broadcastKey  = 'filterCustomers';
  public tableCacheKey = 'customers';

  constructor (
    private apiService      : ApiService,
    private messengerService: MessengerService,
  ) {}

  activate ( customer : CustomerModel ) : Promise<any> {
    return this.apiService.get('/customers/reactivate_deleted', customer.id);
  }

  get ( filters = {} as CustomersFiltersModel, params : TableQueryParameters = {} ) : Promise<Array<CustomerModel>> {
    return this.apiService.stream('/filters', [
        filters.value    || '*',
        'customers',
        params.offset    || 0,
        params.pageSize  || 10,
        params.field     || 'display_name',
        params.direction || 'asc',
        !!filters.archivedOnly
      ]);
  }

  getCount ( filters = {} as CustomersFiltersModel ) : Promise<number> {
    return this.apiService.get('filters/count', [
        filters.value || '*',
        'customers',
        !!filters.archivedOnly
      ]);
  }

  sendEmail ( customer : CustomerModel, message : string ) : Promise<any> {
    return this.messengerService.email({
        attachment_type: 4,
        body           : message,
        customer_id    : customer.id,
        email_address  : customer.email,
        name           : customer.company_name
      });
  }

  sendSms ( customer : CustomerModel ) : Promise<any> {
    return this.messengerService.sms({
        customer_id: customer.id,
        name       : customer.display_name,
        send_to    : customer.mobile
      });
  }
}
